module.exports = __webpack_public_path__ + "img/gift-formyself.27a3598d.svg";